export const ETHNIC_ORIGIN_ACTIONS = {
    FIND: 'FIND_ETHNIC_ORIGINS',
    GET: 'GET_ETHNIC_ORIGINS',
    GET_LIST: 'GET_ETHNIC_ORIGINS_LIST',
    CHANGE_STATUS: 'CHANGE_STATUS_ETHNIC_ORIGINS',
    SUCCESS: 'SUCCESS_ETHNIC_ORIGINS',
    ERROR: 'ERROR_ETHNIC_ORIGINS',
    CLEAN: 'CLEAN_ETHNIC_ORIGINS',
}
